import { useEffect, useState, useRef } from "react";
import GooglePaywall from "./Paywall";
import { checkAccessForAsset, getCookie } from "./story-access";
import { checkAuthStatus } from "../../../../server/helpers/firebase";
import { useSelector, useDispatch } from "react-redux";
import get from "lodash/get";
import React from "react";
import { cdpEventHandler } from "../../../../api/utils";

const RenderPartialContent = ({ contents }) => {
  // Show first 5 paragraphs for non-subscribers
  let text = contents.slice(0, 6).join("");
  text = text.replace(
    /<a/g,
    '<a target="_blank" rel="noopener noreferrer" class="text-primary" style="font-variation-settings: \'slnt\' -6"'
  );
  return (
    <>
      <div
        className="relative flex w-full flex-col gap-[24px] p-6 text-[18px] font-[400] leading-[170%] tablet:text-[17px] "
        id="hide-partial-content"
        dangerouslySetInnerHTML={{
          __html: text,
        }}
      />
    </>
  );
};

const RenderPaywall = (meteringObject, contents, children, storyDetail) => {
  if (
    (meteringObject?.data?.granted === true && meteringObject?.data?.data?.grantDescription === "public") ||
    (meteringObject?.data?.granted === true && meteringObject?.data?.data?.grantDescription === "subscriber")
  ) {
    return children;
  }

  // Handle login required access level
  if (meteringObject?.data?.grantReason === "LOGIN_REQUIRED" && !meteringObject?.data?.granted) {
    return (
      <>
        <RenderPartialContent contents={contents} />
        <GooglePaywall numberRemaining={0} isLoggedIn={false} storyDetail={storyDetail} isLoginRequired={true} />
      </>
    );
  }

  // Handle login required access level - user is logged in
  if (meteringObject?.data?.grantReason === "LOGIN_REQUIRED" && meteringObject?.data?.granted) {
    return children;
  }

  if (
    meteringObject?.data?.grantReason === "METERING" &&
    meteringObject?.data?.granted &&
    !meteringObject?.data?.data?.isLoggedIn
  ) {
    return (
      <>
        <RenderPartialContent contents={contents} />
        <GooglePaywall numberRemaining={meteringObject.data.data.numberRemaining} storyDetail={storyDetail} />
      </>
    );
  }

  if (
    meteringObject?.data?.grantReason === "METERING" &&
    meteringObject?.data?.granted &&
    meteringObject?.data?.data?.isLoggedIn
  ) {
    return children;
  }

  if (!meteringObject?.data?.granted) {
    return (
      <>
        <RenderPartialContent contents={contents} />
        <GooglePaywall
          numberRemaining={0}
          isLoggedIn={meteringObject?.data?.data?.isLoggedIn}
          storyDetail={storyDetail}
        />
      </>
    );
  }
};

const SettingPaywall = ({ children, accessLevel, id, cards, storyDetail }) => {
  const debounceTimeoutRef = useRef(null);
  const getEmail = () => {
    if (typeof window !== "undefined" && window.localStorage) {
      const storedUser = sessionStorage.getItem("SUBSCRIBED_USER");
      return storedUser ? JSON.parse(storedUser) : null;
    }
    return null;
  };

  const getUserProfileId = () => {
    if (typeof window !== "undefined" && window.sessionStorage) {
      const storedProfileId = sessionStorage.getItem("USER_PROFILE_ID");
      return storedProfileId ? JSON.parse(storedProfileId) : null;
    }
    return null;
  };

  const user = useSelector((state) => get(state, ["firebaseUser"], null));
  const profileId = useSelector((state) => get(state, ["userProfileID"], null)) || getUserProfileId();
  const isSubscribed = useSelector((state) => get(state, ["isSubscribedUser"], null)) || getEmail();

  const [contents] = useState([]);
  const [] = useState(() => {
    return cards.map((card) => {
      return card["story-elements"].map((element) => {
        if (element.type === "text" && element.subtype !== "summary") {
          return element.text.split("</p>").map((text) => {
            contents.push(text + "</p>");
          });
        }
      });
    });
  });

  const [meteringObject, setMeteringObject] = useState({
    error: null,
    data: {
      data: { grantDescription: "public", isLoggedIn: false },
      grantReason: "SUBSCRIBER",
      granted: true,
    },
  });

  useEffect(() => {
    async function setUpdatedPaywallResponse() {
      let hasSubs = !user ? false : isSubscribed;
      let loggedIn = user ? true : false;

      let userDetail = loggedIn ? "sub" : null;
      const checkAccess = await checkAccessForAsset(id, accessLevel, userDetail, loggedIn, hasSubs);
      setMeteringObject(checkAccess);
    }

    const timeoutId = setTimeout(() => {
      setUpdatedPaywallResponse();
    }, 1250);

    return () => clearTimeout(timeoutId);
  }, [user, accessLevel, id, isSubscribed]);

  useEffect(() => {
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }
    if (user) {
      debounceTimeoutRef.current = setTimeout(() => {
        let data = {
          email: user.email,
          event_type: "article_read",
          event_time: new Date().toISOString(),
          source: "website",
          story_id: storyDetail["story-content-id"],
          story_headline: storyDetail.headline,
          story_author: storyDetail["author-name"],
          story_sections: storyDetail.sections.map((section) => section.name),
          is_subscribed: isSubscribed,
          profile_id: profileId,
        };
        cdpEventHandler(data);
      }, 1000);
    }

    return () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    };
  }, [user, storyDetail, profileId, isSubscribed]);

  return <>{RenderPaywall(meteringObject, contents, children, storyDetail)}</>;
};

export default SettingPaywall;
